"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../common/helpers/time");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var AWAITING_PAYMENT_STATUSES = ["PAYMENT_FAILED", "PENDING"];
var StudentDashboardController = /** @class */ (function () {
    function StudentDashboardController(UsersModel, UserService, ProductsModel, $sce, $cookies, AuthService, ENV, VueStoreFactory, ReportcardsModel, $state) {
        var _this = this;
        this.ENV = ENV;
        this.loading = true;
        this.UsersModel = UsersModel;
        this.ReportcardsModel = ReportcardsModel;
        this.userHasBalance = false;
        this.UserService = UserService;
        this.schoolHasProducts = false;
        this.using_drive_deadline = false;
        this.courses = [];
        this.$sce = $sce;
        this.$cookies = $cookies;
        this.student = UserService.getCurrentUser();
        this.AuthService = AuthService;
        this.VueStoreFactory = VueStoreFactory;
        this.signaturesRequired = false;
        this.allowSchedulingWithBalance = false;
        this.documentsNeedingAttention = false;
        this.documentsNeedingAttentionCount = 0;
        this.$state = $state;
        this.ordersAwaitingPayment = [];
        ProductsModel.get({ disabled: 0, purchasable: true }).then(function (response) {
            if (response.products.total > 0) {
                _this.schoolHasProducts = true;
            }
        });
        this.goToOnlineDriversEd = this.goToOnlineDriversEd.bind(this);
        this.loadOrdersAwaitingPayment();
        this.setup()
            .then(function (response) {
            _this.loading = false;
        })
            .catch(function (Error) {
            console.log(Error);
            _this.loading = false;
        });
    }
    /**
     * Runs outside setup() so a failure here can never block the dashboard; on
     * any error the prompt simply stays hidden.
     */
    StudentDashboardController.prototype.loadOrdersAwaitingPayment = function () {
        var _this = this;
        this.UsersModel.getStudentOrders({
            student_id: this.student.id,
            awaiting_payment: 1,
        })
            .then(function (response) {
            // The status filter is a guard for an API that predates the
            // awaiting_payment parameter and answers with every order.
            _this.ordersAwaitingPayment = response.orders.data
                .filter(function (order) {
                return order.paid === false &&
                    AWAITING_PAYMENT_STATUSES.includes(order.status);
            })
                .map(function (order) { return ({
                id: order.id,
                uuid: order.uuid,
                status: order.status,
                url: _this.$state.href("drivecoach.student.order", {
                    orderID: order.id,
                }),
            }); });
        })
            .catch(function (Error) {
            console.log(Error);
        });
    };
    StudentDashboardController.prototype.goToOnlineDriversEd = function () {
        var today = new Date(); // Get the current date
        var oneWeekFromNow = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000); // Add 7 days to the current date
        var domain = ".drivescout.build";
        var redirect = window.location.protocol +
            "//driversed.drivescout.local.drivescout.build";
        if (this.ENV === "dev") {
            domain = ".drivescout.com";
            redirect = "https://driversed-dev.drivescout.com";
        }
        else if (this.ENV === "production") {
            domain = ".drivescout.com";
            redirect = "https://driversed.drivescout.com";
        }
        this.$cookies.put("de-auth-token", this.AuthService.getToken(), {
            path: "/",
            domain: domain,
            expires: oneWeekFromNow,
            secure: false,
            samesite: "lax",
        });
        this.$cookies.put("de-auth-id", this.student.id, {
            path: "/",
            domain: domain,
            expires: oneWeekFromNow,
            secure: false,
            samesite: "lax",
        });
        window.location.href = redirect;
    };
    StudentDashboardController.prototype.setup = function () {
        return __awaiter(this, void 0, void 0, function () {
            var student, pickuplocations, nextsessiondata, unsignedReportCards, Error_1, docsNeedingAttention, Error_2, drivePolicy, enableDriveDeadlineMeta, allowSchedulingWithBalance, notificationPolicy, globalNotificationMeta, allowStudentToScheduleMeta, storefrontPolicy, allowPurchaseNewServicesMeta;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStudent()];
                    case 1:
                        student = _a.sent();
                        return [4 /*yield*/, this.getStudentPickupLocations()];
                    case 2:
                        pickuplocations = _a.sent();
                        return [4 /*yield*/, this.getNextSession()];
                    case 3:
                        nextsessiondata = _a.sent();
                        // Check if student is not void before accessing properties
                        if (!student) {
                            return [2 /*return*/];
                        }
                        // Check if pickuplocations is not void before accessing properties
                        if (pickuplocations) {
                            student.pickuplocations = pickuplocations.pickuplocations;
                        }
                        this.user = student;
                        this.deadline = null;
                        this.hasAdminMessage = false;
                        this.canAddPickupLocations = student.school.allows_custom_pickup_locations;
                        this.allowSchedulingWithBalance = true;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.getUnsignedReportCards()];
                    case 5:
                        unsignedReportCards = _a.sent();
                        if (unsignedReportCards) {
                            this.unsignedReportCards = unsignedReportCards.reportcards.data;
                            this.signaturesRequired = unsignedReportCards.reportcards.total > 0;
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        Error_1 = _a.sent();
                        console.log(Error_1);
                        return [3 /*break*/, 7];
                    case 7:
                        _a.trys.push([7, 9, , 10]);
                        return [4 /*yield*/, this.getDocumentsNeedingAttention()];
                    case 8:
                        docsNeedingAttention = _a.sent();
                        this.documentsNeedingAttentionCount = docsNeedingAttention.length;
                        this.documentsNeedingAttention = docsNeedingAttention.length > 0;
                        return [3 /*break*/, 10];
                    case 9:
                        Error_2 = _a.sent();
                        console.log(Error_2);
                        return [3 /*break*/, 10];
                    case 10:
                        if ((0, isEmpty_1.default)(nextsessiondata) || !nextsessiondata) {
                            this.nextDrive = {};
                        }
                        else {
                            this.nextDrive = nextsessiondata.nextDrive;
                            this.nextDriveDate = nextsessiondata.nextDriveDate;
                            this.untilDrive = nextsessiondata.untilDrive;
                        }
                        drivePolicy = this.VueStoreFactory.state.auth.policies.policies.find(function (policy) {
                            return policy.name === "drives";
                        });
                        enableDriveDeadlineMeta = drivePolicy.policymeta.find(function (meta) {
                            return meta.meta_key === "enable_drive_deadline";
                        });
                        allowSchedulingWithBalance = drivePolicy.policymeta.find(function (meta) {
                            return meta.meta_key === "allow_students_with_balances_to_schedule";
                        });
                        if (allowSchedulingWithBalance) {
                            this.allowSchedulingWithBalance =
                                allowSchedulingWithBalance.meta_value === "Y";
                        }
                        if (enableDriveDeadlineMeta && enableDriveDeadlineMeta.meta_value === "Y") {
                            this.using_drive_deadline = true;
                        }
                        else {
                            this.using_drive_deadline = false;
                        }
                        notificationPolicy = this.VueStoreFactory.state.auth.policies.policies.find(function (policy) {
                            return policy.name === "notifications";
                        });
                        globalNotificationMeta = notificationPolicy.policymeta.find(function (meta) {
                            return meta.meta_key === "globalstudentnotification";
                        });
                        if (globalNotificationMeta && globalNotificationMeta.meta_value) {
                            this.hasAdminMessage = true;
                            this.adminMessage = this.$sce.trustAsHtml(globalNotificationMeta.meta_value);
                        }
                        else {
                            this.hasAdminMessage = false;
                            this.adminMessage = null;
                        }
                        this.studentCanSchedule = true;
                        allowStudentToScheduleMeta = drivePolicy.policymeta.find(function (meta) {
                            return meta.meta_key === "allow_students_to_schedule";
                        });
                        if (allowStudentToScheduleMeta) {
                            this.studentCanSchedule = allowStudentToScheduleMeta.meta_value;
                        }
                        storefrontPolicy = this.VueStoreFactory.state.auth.policies.policies.find(function (policy) {
                            return policy.name === "storefront";
                        });
                        allowPurchaseNewServicesMeta = storefrontPolicy.policymeta.find(function (meta) {
                            return (meta.meta_key === "allows_students_to_purchase_new_services_in_app");
                        });
                        this.allowStudentToPurchaseNewServices =
                            (allowPurchaseNewServicesMeta === null || allowPurchaseNewServicesMeta === void 0 ? void 0 : allowPurchaseNewServicesMeta.meta_value) === "Y";
                        if (this.user.hasOwnProperty("deadline") && this.using_drive_deadline) {
                            if (this.user.deadline > 24) {
                                // process as days
                                this.deadline = Math.floor(this.user.deadline / 24);
                                this.deadlineText = (0, time_1.formatDurationHumanize)(this.user.deadline * 60);
                            }
                            else if (this.user.deadline === null) {
                                this.deadline = null;
                            }
                            else {
                                this.deadline = this.user.deadline;
                                this.deadlineText = (0, time_1.formatDurationHumanize)(this.user.deadline * 60);
                            }
                        }
                        this.UsersModel.getStudentBalance(this.user.id).then(function (response) {
                            if (response.balance > 0) {
                                _this.unpaidBalance = response.balance;
                                _this.userHasBalance = true;
                            }
                        });
                        this.getUsageDetail();
                        return [2 /*return*/];
                }
            });
        });
    };
    StudentDashboardController.prototype.userHasFees = function () {
        return this.user.status === "Inactive - Fee";
    };
    StudentDashboardController.prototype.getUsageDetail = function () {
        var _this = this;
        this.UsersModel.getStudentUsageDetails(this.user.id).then(function (response) {
            response.data.Overview.name = "SESSION HOURS OVERVIEW";
            _this.usageoverview = response.data.Overview;
        });
        this.UsersModel.getStudentCourseDetails(this.user.id).then(function (response) {
            _this.courses = response.data;
        });
    };
    StudentDashboardController.prototype.pastStartDate = function () {
        return (0, time_1.isBefore)((0, time_1.dateStringToDate)(this.user.usermeta.start_date), new Date());
    };
    StudentDashboardController.prototype.getNextSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = this.UserService.getCurrentUser();
                return [2 /*return*/, this.UsersModel.getNextStudentEntity({ id: user.id })
                        .then(function (response) {
                        if ((0, isEmpty_1.default)(response.entity)) {
                            return {};
                        }
                        return {
                            nextDrive: response.entity,
                            nextDriveDate: new Date(response.entity.date + " " + response.entity.time),
                            untilDrive: (0, time_1.formatDateTime)(response.entity.date + " " + response.entity.time, "h:mm A"),
                        };
                    })
                        .catch(function (Error) {
                        console.log(Error);
                    })];
            });
        });
    };
    StudentDashboardController.prototype.getStudent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                user = this.UserService.getCurrentUser();
                return [2 /*return*/, this.UsersModel.getStudentByID(user.id)
                        .then(function (response) {
                        if (!response.usermeta.hasOwnProperty("communication")) {
                            response.usermeta.communication = {};
                        }
                        if (response.usermeta.hasOwnProperty("drive_deadline")) {
                            response.usermeta.drive_deadline = (0, time_1.dateStringToDate)(response.usermeta.drive_deadline);
                        }
                        return response;
                    })
                        .catch(function (Error) {
                        console.log(Error);
                    })];
            });
        });
    };
    StudentDashboardController.prototype.getStudentPickupLocations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentUser;
            return __generator(this, function (_a) {
                currentUser = this.UserService.getCurrentUser();
                return [2 /*return*/, this.UsersModel.getPickupLocations(currentUser.id)
                        .then(function (response) {
                        return response;
                    })
                        .catch(function (Error) {
                        console.log(Error);
                    })];
            });
        });
    };
    StudentDashboardController.prototype.getUnsignedReportCards = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.ReportcardsModel.getUnsignedReportCards(this.user.id)
                        .then(function (response) {
                        return response;
                    })
                        .catch(function (Error) {
                        console.log(Error);
                    })];
            });
        });
    };
    StudentDashboardController.prototype.getDocumentsNeedingAttention = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, pending, inProgress, docs;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.VueStoreFactory.dispatch("documents/GET_DOCUMENTS_BY_STATUS", {
                                status: "pending",
                                user_id: this.user.id,
                            }),
                            this.VueStoreFactory.dispatch("documents/GET_DOCUMENTS_BY_STATUS", {
                                status: "in_progress",
                                user_id: this.user.id,
                            }),
                        ])];
                    case 1:
                        _a = _b.sent(), pending = _a[0], inProgress = _a[1];
                        docs = __spreadArray(__spreadArray([], (pending || []), true), (inProgress || []), true);
                        return [2 /*return*/, docs.filter(function (doc) {
                                return (doc.assigned_fields || []).some(function (field) { return !field.completed; });
                            })];
                }
            });
        });
    };
    return StudentDashboardController;
}());
StudentDashboardController.$inject = [
    "UsersModel",
    "UserService",
    "ProductsModel",
    "$sce",
    "$cookies",
    "AuthService",
    "ENV",
    "VueStoreFactory",
    "ReportcardsModel",
    "$state",
];
exports.default = StudentDashboardController;
